module.exports = __webpack_public_path__ + "static/media/ANDATTI.de855005.svg";